<template>
  <div>
    <Footer />

    <tmo-digital-footer v-if="isMagenta"></tmo-digital-footer>
    <tmo-digital-footer v-else brand="metro" client-id="metro"></tmo-digital-footer>

  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

import config from '@/config'
import Footer from '@/components/Footer.vue'
import { openDoNotSellPage } from '@/utils'

@Component({
  components: {
    Footer
  }
})
export default class TheFooter extends Vue {
  private get isMagenta () {
    return config.isMagenta
  }

  private get year () {
    return new Date().getFullYear()
  }

  mounted () {
    const fcomponent = document.querySelector('tmo-digital-footer')
    // eslint-disable-next-line
    fcomponent?.addEventListener('digitalUnavEvent', (event: any) => {
      if (event.detail === 'opendnspage') {
        openDoNotSellPage(this.isMagenta)
      }
    })
  }
}
</script>
